import ajax from '@/api/ajax'
export default {
  wxShowMenu : function(url,params,hasSuffix) {
    const suffix = '?x-oss-process=image/resize,m_fill,h_300,w_300'
    ajax(`${url}`,params).then(function(res){
      var getMsg = res.data;
      wx.config({
        debug: false,  //生产环境需要关闭debug模式
        appId: getMsg.signPackage.appId, //appId通过微信服务号后台查看
        timestamp: getMsg.signPackage.timestamp, //生成签名的时间戳
        nonceStr: getMsg.signPackage.nonceStr, //生成签名的随机字符串
        signature: getMsg.signPackage.signature, //签名
        jsApiList: [ //需要调用的JS接口列表
          'onMenuShareTimeline', //分享给好友
          'onMenuShareAppMessage', //分享到朋友圈
          'showMenuItems',
          'hideMenuItems'
        ]
      });
      wx.ready(function() {
        wx.onMenuShareTimeline({
          title: getMsg.showTitle, // 分享标题
          desc: getMsg.showDesc, //分享描述
          link: getMsg.showLink,// 分享链接
          imgUrl:hasSuffix ? `${getMsg.showImg}${suffix}` : getMsg.showImg // 分享图标
        });
        wx.onMenuShareAppMessage({
          title: getMsg.showTitle, // 分享标题
          desc: getMsg.showDesc, // 分享描述
          link: getMsg.showLink, // 分享链接
          imgUrl: hasSuffix ? `${getMsg.showImg}${suffix}` : getMsg.showImg // 分享图标
        });
      });
    })
  }
}
